import { AppState } from '../index';

export const guestTypesSelector = (state: AppState) =>
  state.guestTypes.data || [];
export const guestTypeStatusSelector = (state: AppState) =>
  state.guestTypes.status;
